import {Component} from '@angular/core';
/**
 * \@title Basic Inputs
 */
export class InputOverviewExample {static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'input-overview-example',
  styleUrls: ['input-overview-example.css'],
  templateUrl: 'input-overview-example.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function InputOverviewExample_tsickle_Closure_declarations() {
/** @type {?} */
InputOverviewExample.decorators;
/**
 * @nocollapse
 * @type {?}
 */
InputOverviewExample.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
